import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './+state';
import { CsatEffects } from './+state/csat.effects';
import { CsatFacade } from './+state/csat.facade';
import { CsatModalService } from './csat-modal.service';
import { CsatModalComponent } from './csat-modal/csat-modal.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('shared/csat', reducer),
    EffectsModule.forFeature([CsatEffects]),
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule
  ],
  declarations: [CsatModalComponent],
  providers: [CsatModalService, CsatFacade],
  exports: [
    CsatModalComponent
  ]
})

export class CsatModule {
}
